import b2bRoutes from "../b2b/router";
import reports_routes from "../reports-aggrid/router";
import reports_point_of_sale from "../point_of_sale/router";
import $http from "../axios";

const baseRoutes = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/inicio",
    component: resolve => require(["../views/default.vue"], resolve),
    children: [
      {
        path: "",
        component: resolve =>
          require(["../components/pages/index.vue"], resolve),
        meta: {
          title: "Dashboard",
          breadcrumb: [
            {
              text: " Dashboard 1",
              href: "/"
            }
          ]
        }
      },
      //Kevin Galindo Test
      {
        path: "/PageTest",
        component: resolve =>
          require(["../components/pages/pricing.vue"], resolve),
        meta: {
          title: "PageTest",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "PageTest",
              href: "#/PageTest"
            }
          ]
        }
      },
      // roles y permisos
      {
        path: "/roles-permisos",
        component: resolve => require(["../views/roles/index.vue"], resolve),
        meta: {
          title: "Permisos de Usuario",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Roles",
              href: "#/roles-permisos"
            }
          ]
        }
      },
      {
        path: "/rol/crear",
        component: resolve => require(["../views/roles/form.vue"], resolve),
        meta: {
          title: "Permisos de Usuario",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Roles",
              href: "#/rol/crear"
            }
          ]
        }
      },
      {
        path: "/rol/:id/editar",
        component: resolve => require(["../views/roles/form.vue"], resolve),
        meta: {
          title: "Permisos de Usuario",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Roles",
              href: "#/rol/:id/editar"
            }
          ]
        }
      },
      {
        path: "/rol/:idv/ver",
        component: resolve => require(["../views/roles/form.vue"], resolve),
        meta: {
          title: "Permisos de Usuario",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Roles",
              href: "#/rol/:idv/ver"
            }
          ]
        }
      },

      //   envio automatico de la cartera
      {
        path: "/envio-cartera",
        component: resolve =>
          require(["../views/automatic-portfolio-delivery/index.vue"], resolve),
        meta: {
          title: "Envio Automatico de Cartera",
          permission: "Informe Automatico Cartera",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Envio Automatico de Cartera",
              href: "#/envio-cartera"
            }
          ]
        }
      },

      //   crear  automatico de la cartera
      {
        path: "/nuevo-envio-cartera",
        component: resolve =>
          require([
            "../views/automatic-portfolio-delivery/maintenance.vue"
          ], resolve),
        meta: {
          title: "Crear Configuracón Envio Automatico de Cartera",
          permission: "Informe Automatico Cartera",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Licencias",
              href: "#/licencias"
            }
          ]
        }
      },
      {
        path: "/licencias",
        component: resolve => require(["../views/licenses/index.vue"], resolve),
        meta: {
          title: "Licencias",
          permission: "Licencias",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Licencias",
              href: "#/licencias"
            }
          ]
        }
      },
      {
        path: "/impuestos",
        component: resolve => require(["../views/taxes/index.vue"], resolve),
        meta: {
          title: "Impuestos",
          permission: "Impuestos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Impuestos",
              href: "#/impuestos"
            }
          ]
        }
      },
      {
        path: "/impuestos/crear",
        component: resolve => require(["../views/taxes/tax-form.vue"], resolve),
        meta: {
          title: "Impuestos",
          permission: "Impuestos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Impuestos",
              href: "#/impuestos"
            }
          ]
        }
      },
      {
        path: "/impuestos/:id/editar",
        component: resolve => require(["../views/taxes/tax-form.vue"], resolve),
        meta: {
          title: "Impuestos",
          permission: "Impuestos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Impuestos",
              href: "#/impuestos"
            }
          ]
        }
      },
      {
        path: "/impuestos/:idv/ver",
        component: resolve => require(["../views/taxes/tax-form.vue"], resolve),
        meta: {
          title: "Impuestos",
          permission: "Impuestos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Impuestos",
              href: "#/impuestos"
            }
          ]
        }
      },
      //   promociones
      {
        path: "/promociones",
        component: resolve =>
          require(["../views/promotions/index.vue"], resolve),
        meta: {
          title: "Promociones",
          permission: "Promociones",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Promociones",
              href: "#/promociones"
            }
          ]
        }
      },
      {
        path: "/promociones/crear",
        component: resolve =>
          require(["../views/promotions/promotion-form.vue"], resolve),
        meta: {
          title: "Promociones",
          permission: "Promociones",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Promociones",
              href: "#/promociones"
            }
          ]
        }
      },
      {
        path: "/promociones/:id/editar",
        component: resolve =>
          require(["../views/promotions/promotion-form.vue"], resolve),
        meta: {
          title: "Promociones",
          permission: "Promociones",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Promociones",
              href: "#/promociones"
            }
          ]
        }
      },
      {
        path: "/promociones/:idv/ver",
        component: resolve =>
          require(["../views/promotions/promotion-form.vue"], resolve),
        meta: {
          title: "Promociones",
          permission: "Promociones",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Promociones",
              href: "#/promociones"
            }
          ]
        }
      },
      {
        path: "/licencias/crear",
        component: resolve =>
          require(["../views/licenses/maintenance.vue"], resolve),
        meta: {
          title: "Licencias",
          permission: "Licencias",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Licencias",
              href: "#/licencias"
            },
            {
              text: "Crear Licencia",
              href: "#/licencias/crear"
            }
          ]
        }
      },
      {
        path: "/licencias/:id/editar",
        component: resolve =>
          require(["../views/licenses/maintenance.vue"], resolve),
        meta: {
          title: "Licencias",
          permission: "Licencias",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Licencias",
              href: "#/licencias"
            },
            {
              text: "Editar Licencia",
              href: "#/licencias/:id/editar"
            }
          ]
        }
      },
      {
        path: "/licencias/:idv/ver",
        component: resolve =>
          require(["../views/licenses/maintenance.vue"], resolve),
        meta: {
          title: "Licencias",
          permission: "Licencias",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Licencias",
              href: "#/licencias"
            },
            {
              text: "Detalle Licencia",
              href: "#/licencias/:idv/ver"
            }
          ]
        }
      },
      {
        path: "/suscriptores",
        component: resolve =>
          require(["../views/subscribers/index.vue"], resolve),
        meta: {
          title: "Suscriptores",
          permission: "Suscriptores",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Suscriptores",
              href: "#/suscriptores"
            }
          ]
        }
      },
      {
        path: "/suscriptores/crear",
        component: resolve =>
          require(["../views/subscribers/wizarFormSubscriber.vue"], resolve),
        meta: {
          title: "Suscriptores",
          permission: "Suscriptores",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Suscriptores",
              href: "#/suscriptores"
            },
            {
              text: "Mantenimiento Suscriptores",
              href: "#/suscriptores/crear"
            }
          ]
        }
      },
      {
        path: "/suscriptores/:id/editar",
        component: resolve =>
          require(["../views/subscribers/wizarFormSubscriber.vue"], resolve),
        meta: {
          title: "Suscriptores",
          permission: "Suscriptores",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Suscriptores",
              href: "#/suscriptores"
            },
            {
              text: "Mantenimiento Suscriptores",
              href: "#/suscriptores/:id/editar"
            }
          ]
        }
      },
      {
        path: "/suscriptores/:idv/ver",
        component: resolve =>
          require(["../views/subscribers/wizarFormSubscriber.vue"], resolve),
        meta: {
          title: "Suscriptores",
          permission: "Suscriptores",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Suscriptores",
              href: "#/suscriptores"
            },
            {
              text: "Suscriptores",
              href: "#/suscriptores/:idv/ver"
            }
          ]
        }
      },
      {
        path: "/tablas-parametros",
        component: resolve =>
          require(["../views/param-tables/index.vue"], resolve),
        meta: {
          title: "Tablas de parámetros",
          permission: "Tablas de parámetro",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Tablas de parametros",
              href: "#/tablas-parametros"
            }
          ]
        }
      },
      {
        path: "/tablas-parametros/crear",
        component: resolve =>
          require(["../views/param-tables/maintenance.vue"], resolve),
        meta: {
          title: "Tablas de parámetros",
          permission: "Tablas de parámetro",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Tablas de parametros",
              href: "#/tablas-parametros"
            },
            {
              text: "Crear Tabla de Parametros",
              href: "#/tablas-parametros/crear"
            }
          ]
        }
      },
      {
        path: "/contabilizacion-operaciones-inventario",
        component: resolve =>
          require([
            "../views/accounting-inventory-movements/Index.vue"
          ], resolve),
        meta: {
          title: "Contabilizacion Operaciones Inventario",
          permission: "",
          breadcrumb: []
        }
      },
      {
        path: "/tablas-parametros/:id/editar",
        component: resolve =>
          require(["../views/param-tables/maintenance.vue"], resolve),
        meta: {
          title: "Tablas de parámetros",
          permission: "Tablas de parámetro",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Tablas de parametros",
              href: "#/tablas-parametros"
            },
            {
              text: "Editar Tabla de Parametros",
              href: "#/tablas-parametros/:id/editar"
            }
          ]
        }
      },
      {
        path: "/tablas-parametros/:idv/ver",
        component: resolve =>
          require(["../views/param-tables/maintenance.vue"], resolve),
        meta: {
          title: "Tablas de parámetros",
          permission: "Tablas de parámetro",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Tablas de parametros",
              href: "#/tablas-parametros"
            },
            {
              text: "Detalle Tabla de Parametros",
              href: "#/tablas-parametros/:idv/ver"
            }
          ]
        }
      },
      {
        path: "/tipos-de-comprobantes",
        component: resolve =>
          require(["../views/vouchers-types/index.vue"], resolve),
        meta: {
          title: "Tipos de comprobantes",
          permission: "Tipos de comprobantes",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Tipos de comprobantes",
              href: "#/tipos-de-comprobantes"
            }
          ]
        }
      },
      {
        path: "/tipos-de-comprobantes/crear",
        component: resolve =>
          require(["../views/vouchers-types/maintenance.vue"], resolve),
        meta: {
          title: "Tipos de comprobantes",
          permission: "Tipos de comprobantes",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Tipos de comprobantes",
              href: "#/tipos-de-comprobantes"
            },
            {
              text: "Crear Tipo de comprobante",
              href: "#/tipos-de-comprobantes/crear"
            }
          ]
        }
      },
      {
        path: "/tipos-de-comprobantes/:id/editar",
        component: resolve =>
          require(["../views/vouchers-types/maintenance.vue"], resolve),
        meta: {
          title: "Tipos de comprobantes",
          permission: "Tipos de comprobantes",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Tipos de comprobantes",
              href: "#/tipos-de-comprobantes"
            },
            {
              text: "Editar Tipo de comprobante",
              href: "#/tipos-de-comprobantes/:id/editar"
            }
          ]
        }
      },
      {
        path: "/tipos-de-comprobantes/:idv/ver",
        component: resolve =>
          require(["../views/vouchers-types/maintenance.vue"], resolve),
        meta: {
          title: "Tipos de comprobantes",
          permission: "Tipos de comprobantes",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Tipos de comprobantes",
              href: "#/tipos-de-comprobantes"
            },
            {
              text: "Detalle Tipo de Comprobante",
              href: "#/tipos-de-comprobantes/:idv/ver"
            }
          ]
        }
      },
      {
        path: "/medios-magneticos-parametros",
        component: resolve => require(["../views/magneticMedia/Index.vue"], resolve),
        meta: {
          title: "Medios Magneticos Parametros",
          permission: "Medios Magneticos Parametros",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Medios Magneticos Parametros",
              href: "#/medios-magneticos-parametros"
            }
          ]
        }
      },
      {
        path: "/reporte-de-medios-magneticos",
        component: resolve =>
          require(["../reports-aggrid/views/ReportMagneticMedia/redirect.vue"], resolve),
        meta: {
          title: "Reporte de medios magneticos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Reporte de cartera",
              href: "#/reporte-de-medios-magneticos"
            }
          ]
        }
      },
      {
        path: "/terceros",
        // component: resolve => require(['../components/pages/gmaps.vue'], resolve),
        component: resolve => require(["../views/contacts/index.vue"], resolve),
        meta: {
          title: "Terceros",
          permission: "Terceros",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Terceros",
              href: "#/terceros"
            }
          ]
        }
      },
      {
            path: "/terceros/importar",
            component: resolve =>
                require(["../views/import-terceros/index.vue"], resolve),
            meta: {
                title: "Importar Terceros",
                permission: "Importar Terceros",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Importar Terceros",
                        href: "#/terceros/importar"
                    }
                ]
            }
        },
      {
        path: "/terceros/crear",
        component: resolve =>
          require(["../views/contacts/maintenance.vue"], resolve),
        meta: {
          title: "Terceros",
          permission: "Terceros",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Terceros",
              href: "#/terceros"
            }
          ]
        }
      },
      {
        path: "/terceros/:id/editar",
        component: resolve =>
          require(["../views/contacts/maintenance.vue"], resolve),
        meta: {
          title: "Terceros",
          permission: "Terceros",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Terceros",
              href: "#/terceros"
            },
            {
              text: "Terceros",
              href: "#/terceros/:id/editar"
            }
          ]
        }
      },
      {
        path: "/terceros/:idv/ver",
        component: resolve =>
          require(["../views/contacts/maintenance.vue"], resolve),
        meta: {
          title: "Terceros",
          permission: "Terceros",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Terceros",
              href: "#/terceros"
            },
            {
              text: "Terceros",
              href: "#/terceros/:idv/ver"
            }
          ]
        }
      },
      {
        path: "/proyecto",
        component: resolve => require(["../views/projects/index.vue"], resolve),
        meta: {
          title: "Proyecto",
          permission: "Proyecto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Proyecto",
              href: "#/proyecto"
            }
          ]
        }
      },
      {
        path: "/proyecto/crear",
        component: resolve =>
          require(["../views/projects/maintenance.vue"], resolve),
        meta: {
          title: "Proyecto",
          permission: "Proyecto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Proyecto",
              href: "#/proyecto"
            }
          ]
        }
      },
      {
        path: "/proyecto/:id/editar",
        component: resolve =>
          require(["../views/projects/maintenance.vue"], resolve),
        meta: {
          title: "Proyecto",
          permission: "Proyecto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Proyecto",
              href: "#/proyecto"
            }
          ]
        }
      },
      {
        path: "/proyecto/:idv/ver",
        component: resolve =>
          require(["../views/projects/maintenance.vue"], resolve),
        meta: {
          title: "Proyecto",
          permission: "Proyecto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Proyecto",
              href: "#/proyecto"
            }
          ]
        }
      },
      {
        path: "/sedes",
        component: resolve =>
          require(["../views/branch-offices/index.vue"], resolve),
        meta: {
          title: "Sedes",
          permission: "Sedes",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sedes",
              href: "#/sedes"
            }
          ]
        }
      },
      {
        path: "/sedes/crear",
        component: resolve =>
          require(["../views/branch-offices/maintenance.vue"], resolve),
        meta: {
          title: "Sedes",
          permission: "Sedes",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sedes",
              href: "#/sedes"
            }
          ]
        }
      },
      {
        path: "/sedes/:id/editar",
        component: resolve =>
          require(["../views/branch-offices/maintenance.vue"], resolve),
        meta: {
          title: "Sedes",
          permission: "Sedes",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sedes",
              href: "#/sedes"
            },
            {
              text: "Sedes",
              href: "#/sedes/:id/editar"
            }
          ]
        }
      },
      {
        path: "/sedes/:idv/ver",
        component: resolve =>
          require(["../views/branch-offices/maintenance.vue"], resolve),
        meta: {
          title: "Sedes",
          permission: "Sedes",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sedes",
              href: "#/sedes"
            },
            {
              text: "Sedes",
              href: "#/sedes/:idv/ver"
            }
          ]
        }
      },
      {
        path: "/lineas",
        component: resolve => require(["../views/lines/index.vue"], resolve),
        meta: {
          title: "Lineas",
          permission: "Lineas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Lineas",
              href: "#/lineas"
            }
          ]
        }
      },
      {
        path: "/lineas/crear",
        component: resolve =>
          require(["../views/lines/maintenance.vue"], resolve),
        meta: {
          title: "Lineas",
          permission: "Lineas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Lineas",
              href: "#/lineas"
            }
          ]
        }
      },
      {
        path: "/lineas/:id/editar",
        component: resolve =>
          require(["../views/lines/maintenance.vue"], resolve),
        meta: {
          title: "Lineas",
          permission: "Lineas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Lineas",
              href: "#/lineas"
            },
            {
              text: "Lineas",
              href: "#/lineas/:id/editar"
            }
          ]
        }
      },
      {
        path: "/lineas/:idv/ver",
        component: resolve =>
          require(["../views/lines/maintenance.vue"], resolve),
        meta: {
          title: "Lineas",
          permission: "Lineas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Lineas",
              href: "#/lineas"
            },
            {
              text: "Lineas",
              href: "#/lineas/:idv/ver"
            }
          ]
        }
      },
      {
        path: '/jefaturas',
        component: resolve => require(['../views/leadership/index.vue'], resolve),
        meta: {
          title: 'Jefaturas',
          permission: 'Jefaturas',
          breadcrumb: [{
            text: ' Dashboard',
            href: '#/',
          }, {
            text: 'Administración Starcommerce',
            href: '#',
          }, {
            text: 'Jefaturas',
            href: '#/jefaturas',
          }]
        }
      },
      {
        path: '/jefaturas/crear',
        component: resolve => require(['../views/leadership/maintenance.vue'], resolve),
        meta: {
          title: 'Jefaturas',
          permission: 'Jefaturas',
          breadcrumb: [{
            text: ' Dashboard',
            href: '#/',
          }, {
            text: 'Administración Starcommerce',
            href: '#',
          }, {
            text: 'Jefaturas',
            href: '#/licencias',
          }, {
            text: 'Crear Jefatura',
            href: 'jefaturas/crear',
          }]
        }
      },
      {
        path: '/jefaturas/:idv/ver',
        component: resolve => require(['../views/leadership/maintenance.vue'], resolve),
        meta: {
          title: 'Jefaturas',
          permission: 'Jefaturas',
          breadcrumb: [{
            text: ' Dashboard',
            href: '#/',
          }, {
            text: 'Administración Starcommerce',
            href: '#',
          }, {
            text: 'Jefaturas',
            href: '#/jefaturas',
          }, {
            text: 'Detalle Licencia',
            href: '#/jefaturas/:idv/ver',
          }]
        }
      },
      {
        path: '/jefaturas/:id/editar',
        component: resolve => require(['../views/leadership/maintenance.vue'], resolve),
        meta: {
          title: 'Jefaturas',
          permission: 'Jefaturas',
          breadcrumb: [{
            text: ' Dashboard',
            href: '#/',
          }, {
            text: 'Administración Starcommerce',
            href: '#',
          }, {
            text: 'Jefaturas',
            href: '#/jefaturas',
          }, {
            text: 'Detalle Licencia',
            href: '#/jefaturas/:id/editar',
          }]
        }
      },
      {
        path: "/usuarios",
        component: resolve => require(["../views/users/index.vue"], resolve),
        meta: {
          title: "Usuarios",
          permission: "Usuarios",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Usuarios",
              href: "#/usuarios"
            }
          ]
        }
      },
      {
        path: "/usuarios/crear",
        component: resolve =>
          require(["../views/users/maintenance.vue"], resolve),
        meta: {
          title: "Usuarios",
          permission: "Usuarios",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Usuarios",
              href: "#/licencias"
            },
            {
              text: "Crear Usuario",
              href: "usuarios/crear"
            }
          ]
        }
      },
      {
        path: "/usuarios/:id/editar",
        component: resolve =>
          require(["../views/users/maintenance.vue"], resolve),
        meta: {
          title: "Usuarios",
          permission: "Usuarios",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Usuarios",
              href: "#/usuarios"
            },
            {
              text: "Detalle Licencia",
              href: "#/usuarios/:id/editar"
            }
          ]
        }
      },
      {
        path: "/usuarios/:idv/ver",
        component: resolve =>
          require(["../views/users/maintenance.vue"], resolve),
        meta: {
          title: "Usuarios",
          permission: "Usuarios",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Usuarios",
              href: "#/usuarios"
            },
            {
              text: "Detalle Licencia",
              href: "#/usuarios/:idv/ver"
            }
          ]
        }
      },
      {
        path: "blank",
        component: resolve =>
          require(["../components/pages/blank.vue"], resolve),
        meta: {
          title: "Blank",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Extra Pages",
              href: "#"
            },
            {
              text: "Blank",
              href: "#/blank"
            }
          ]
        }
      },
      {
        path: "/marcas",
        component: resolve => require(["../views/brands/index.vue"], resolve),
        meta: {
          title: "Marcas",
          permission: "Marcas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Marcas",
              href: "#/marcas"
            }
          ]
        }
      },
      {
        path: "/marcas/crear",
        component: resolve =>
          require(["../views/brands/maintenance.vue"], resolve),
        meta: {
          title: "Marcas",
          permission: "Marcas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Marcas",
              href: "#/marcas"
            }
          ]
        }
      },
      {
        path: "/marcas/:id/editar",
        component: resolve =>
          require(["../views/brands/maintenance.vue"], resolve),
        meta: {
          title: "Marcas",
          permission: "Marcas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Marcas",
              href: "#/marcas"
            },
            {
              text: "Marcas",
              href: "#/marcas/:id/editar"
            }
          ]
        }
      },
      {
        path: "/marcas/:idv/ver",
        component: resolve =>
          require(["../views/brands/maintenance.vue"], resolve),
        meta: {
          title: "Marcas",
          permission: "Marcas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Marcas",
              href: "#/marcas"
            },
            {
              text: "Marcas",
              href: "#/marcas/:idv/ver"
            }
          ]
        }
      },
      {
        path: "/categorias",
        component: resolve =>
          require(["../views/categories/index.vue"], resolve),
        meta: {
          title: "Categorias",
          permission: "Categorias",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Categorias",
              href: "#/categorias"
            }
          ]
        }
      },
      {
        path: "/categorias/crear",
        component: resolve =>
          require(["../views/categories/maintenance.vue"], resolve),
        meta: {
          title: "Categorias",
          permission: "Categorias",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Categorias",
              href: "#/categorias"
            }
          ]
        }
      },
      {
        path: "/categorias/:id/editar",
        component: resolve =>
          require(["../views/categories/maintenance.vue"], resolve),
        meta: {
          title: "Categorias",
          permission: "Categorias",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Categorias",
              href: "#/categorias"
            },
            {
              text: "Categorias",
              href: "#/categorias/:id/editar"
            }
          ]
        }
      },
      {
        path: "/categorias/:idv/ver",
        component: resolve =>
          require(["../views/categories/maintenance.vue"], resolve),
        meta: {
          title: "Categorias",
          permission: "Categorias",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Categorias",
              href: "#/categorias"
            },
            {
              text: "Categorias",
              href: "#/categorias/:idv/ver"
            }
          ]
        }
      },
      {
        path: "/configuracion-menu",
        component: resolve =>
          require(["../views/menu/maintenance.vue"], resolve),
        meta: {
          title: "Configuración de menú",
          permission: "Configuración menú",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Configuración de menú",
              href: "#/configuracion-menu"
            }
          ]
        }
      },
      {
        path: "/banners",
        component: resolve =>
          require(["../views/banners_b2b/index.vue"], resolve),
        meta: {
          title: "Banners",
          permission: "Banners",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Banners",
              href: "#/banners"
            }
          ]
        }
      },
      {
        path: "/banners/crear",
        component: resolve =>
          require(["../views/banners_b2b/maintenance.vue"], resolve),
        meta: {
          title: "Banners",
          permission: "Banners",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Banners",
              href: "#/banners"
            }
          ]
        }
      },
      {
        path: "/documentos-inventario/:model_id",
        component: resolve =>
          require(["../views/base-documents/index.vue"], resolve),
        props: true,
        meta: {
          title: "",
          permission: "",
          function_execute: async model_id => {
            let model = JSON.parse(localStorage.getItem("selectedModel"));

            if (!model || +model.id !== +model_id) {
              await $http.get("/api/modelos/" + model_id).then(response => {
                model = response.data.data;
                localStorage.setItem("selectedModel", JSON.stringify(model));
              });
            }

            if (model.doc_base_management !== 2) {
              return model.code + " " + model.description;
            }
          },
          parameter: "model_id",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/documentos-inventario"
            }
          ]
        }
      },
      {
        path: "/documentos-por-autorizar/",
        component: resolve =>
          require(["../views/authorize_documents/index.vue"], resolve),
        props: true,
        meta: {
          title: "Documentos Por Autorizar",
          permission: "Banners",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Documentos Por Autorizar",
              href: "#/documentos-por-autorizar"
            }
          ]
        }
      },
      {
        path: "/autorizacion-de-documentos/",
        component: resolve =>
          require(["../views/authorize_documents/index.vue"], resolve),
        props: true,
        meta: {
          title: "Informe de documentos autorizados",
          permission: "Banners",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Informe de documentos autorizados",
              href: "#/autorizacion-de-documentos"
            }
          ]
        }
      },
      {
        path: "/nuevo-informe",
        component: resolve =>
          require(["../views/nuevo-informe/index.vue"], resolve),
        meta: {
          title: "Nuevo Informe",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Nuevo Informe",
              href: "#/nuevo-informe"
            }
          ]
        }
      },
      {
        path: "/banners/:id/editar",
        component: resolve =>
          require(["../views/banners_b2b/maintenance.vue"], resolve),
        meta: {
          title: "Banners",
          permission: "Banners",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Banners",
              href: "#/banners"
            },
            {
              text: "Banners",
              href: "#/banners/:id/editar"
            }
          ]
        }
      },
      {
        path: '/cargue-presupuesto',
        component: resolve => require(['../views/sales_budgets/maintenance.vue'], resolve),
        meta: {
          title: 'Cargue de Presupuesto',
          permission: 'Cargue Presupuesto',
          breadcrumb: [{
            text: ' Dashboard',
            href: '#/'
          },
          {
            text: 'B2B',
            href: '#'
          },
          {
            text: 'Cargue de Presupuesto',
            href: '#/cargue_presupuesto'
          }
          ]
        }
      },
        {
            path: '/cargue-presupuesto-clientes',
            component: resolve => require(['../views/sales_budget_by_contacts_warehouses/maintenance.vue'], resolve),
            meta: {
                title: 'Cargue de Presupuesto por cliente',
                permission: 'Cargue Presupuesto',
                breadcrumb: [{
                    text: ' Dashboard',
                    href: '#/'
                },
                    {
                        text: 'B2B',
                        href: '#'
                    },
                    {
                        text: 'Cargue de Presupuesto por cliente',
                        href: '#/cargue_presupuesto'
                    }
                ]
            }
        },
      {
        path: '/gestion-presupuesto',
        component: resolve => require(['../views/sales_budgets/report.vue'], resolve),
        meta: {
          title: 'Gestión presupuesto',
          permission: 'Gestión presupuesto',
          breadcrumb: [{
            text: ' Dashboard',
            href: '#/'
          },
          {
            text: 'Reportes',
            href: '#'
          },
          {
            text: 'Gestión presupuesto',
            href: '#/Gestión presupuesto'
          }
          ]
        }
      },
        {
            path: '/gestion-presupuesto-clientes',
            component: resolve => require(['../views/sales_budget_by_contacts_warehouses/report.vue'], resolve),
            meta: {
                title: 'Gestión presupuesto',
                permission: 'Gestión presupuesto',
                breadcrumb: [{
                    text: ' Dashboard',
                    href: '#/'
                },
                    {
                        text: 'Reportes',
                        href: '#'
                    },
                    {
                        text: 'Gestión presupuesto',
                        href: '#/Gestión presupuesto'
                    }
                ]
            }
        },
      {
        path: "/ecommerce",
        component: resolve =>
          require(["../views/ecommerce/maintenance.vue"], resolve),
        meta: {
          title: "Portal Clientes",
          permission: "Portal clientes",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Portal Clientes",
              href: "#/ecommerce"
            }
          ]
        }
      },
      {
        path: "/cliente-prospecto",
        component: resolve =>
          require(["../views/ecommerce/prospective-client.vue"], resolve),
        meta: {
          title: "Cliente Prospecto",
          permission: "Formulario Cliente Prospecto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Cliente Prospecto",
              href: "#/cliente Prospecto"
            }
          ]
        }
      },
      {
        path: "/gestion-de-cobranzas",
        component: resolve =>
          require(["../views/payment-managment/paymentManagment.vue"], resolve),
        meta: {
          title: "Gestion De Cobranzas",
          permission: "Gestion De Cobranza",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Terceros",
              href: "#/terceros"
            }
          ]
        }
      },
      {
        path: "/ruta-vendedor",
        component: resolve =>
          require(["../views/ecommerce/coordinate-seller.vue"], resolve),
        meta: {
          title: "Ruta vendedor",
          permission: "Ruta vendedor",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Ruta vendedor",
              href: "#/ruta-vendedor"
            }
          ]
        }
      },
      {
        path: "/seguimiento-vendedores",
        component: resolve => require(["../views/visits/index.vue"], resolve),
        meta: {
          title: "Visitas de vendedores",
          permission: "Visitas vendedor",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Visitas de vendedores",
              href: "#/seguimiento-vendedores"
            }
          ]
        }
      },
      {
        path: "/ficha-de-datos",
        component: resolve =>
          require(["../views/data_sheet/index.vue"], resolve),
        meta: {
          title: "Atributos Producto",
          permission: "Atributos Producto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "ficha-de-datos",
              href: "#/ficha-de-datos"
            }
          ]
        }
      },
      {
        path: "/ficha-de-datos/crear",
        component: resolve =>
          require(["../views/data_sheet/maintenance.vue"], resolve),
        meta: {
          action: "create",
          permission: "Atributos Producto",
          title: "Atributos Producto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Atributos Producto",
              href: "#/ficha-de-datos/crear"
            }
          ]
        }
      },
      {
        path: "/ficha-de-datos/:id/editar",
        component: resolve =>
          require(["../views/data_sheet/maintenance.vue"], resolve),
        meta: {
          action: "edit",
          title: "Atributos Producto",
          permission: "Atributos Producto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Atributos Producto",
              href: "#/ficha-de-datos/:id/editar"
            }
          ]
        }
      },
      {
        path: "/ficha-de-datos/:id/ver",
        component: resolve =>
          require(["../views/data_sheet/maintenance.vue"], resolve),
        meta: {
          action: "view",
          title: "ficha-de-datos",
          permission: "Atributos Producto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "ficha-de-datos",
              href: "#/ficha-de-datos/:id/editar"
            }
          ]
        }
      },
      {
        path: "/productos",
        component: resolve => require(["../views/products/index.vue"], resolve),
        meta: {
          title: "Productos",
          permission: "Productos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Productos",
              href: "#/productos"
            }
          ]
        }
      },
        {
            path: "/imagenes-productos",
            component: resolve => require(["../views/load_images/index.vue"], resolve),
            meta: {
                title: "Imágenes productos",
                permission: "Productos",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Imágenes productos",
                        href: "#/imagenes-productos"
                    }
                ]
            }
        },
      {
        path: "/productos/importar",
        component: resolve =>
          require(["../views/import-products/index.vue"], resolve),
        meta: {
          title: "Importar Productos",
          permission: "Importar Productos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Importar Productos",
              href: "#/productos/importar"
            }
          ]
        }
      },
      {
        path: "/productos/crear",
        component: resolve =>
          require(["../views/products/productForm.vue"], resolve),
        meta: {
          title: "Productos",
          permission: "Productos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Productos",
              href: "#/productos"
            }
          ]
        }
      },
      {
        path: "/productos/:idv/ver",
        component: resolve =>
          require(["../views/products/productForm.vue"], resolve),
        meta: {
          title: "Productos",
          permission: "Productos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Productos",
              href: "#/productos/:idv/ver"
            }
          ]
        }
      },
      {
        path: "/productos/:id/editar",
        component: resolve =>
          require(["../views/products/productForm.vue"], resolve),
        meta: {
          title: "Productos",
          permission: "Productos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Productos",
              href: "#/productos/:id/editar"
            }
          ]
        }
      },
      {
        path: "/fecha-firme",
        component: resolve => require(["../views/dateFirm/index.vue"], resolve),
        meta: {
          title: "Fecha Firme",
          permission: "FECHA FIRME",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Fecha Firme",
              href: "#/fecha-firme"
            }
          ]
        }
      },
      {
        path: "/activos-fijos",
        component: resolve =>
          require(["../views/fixAssets/index.vue"], resolve),
        meta: {
          title: "Activos Fijos",
          permission: "ACTIVOS FIJOS",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Activos Fijos",
              href: "#/activos-fijos"
            }
          ]
        }
      },
      {
        path: "/activos-fijos/crear",
        component: resolve =>
          require(["../views/fixAssets/maintenance.vue"], resolve),
        meta: {
          title: "Activos Fijos",
          permission: "ACTIVOS FIJOS",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Activos Fijos",
              href: "#/activos-fijos"
            }
          ]
        }
      },
      {
        path: "/activos-fijos/:idv/ver",
        component: resolve =>
          require(["../views/fixAssets/maintenance.vue"], resolve),
        meta: {
          title: "Activos Fijos",
          permission: "ACTIVOS FIJOS",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Activos Fijos",
              href: "#/activos-fijos/:idv/ver"
            }
          ]
        }
      },
      {
        path: "/activos-fijos/:id/editar",
        component: resolve =>
          require(["../views/fixAssets/maintenance.vue"], resolve),
        meta: {
          title: "Activos Fijos",
          permission: "ACTIVOS FIJOS",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Activos Fijos",
              href: "#/activos-fijos/:id/editar"
            }
          ]
        }
      },
      {
        path: "/read-products",
        component: resolve =>
          require(["../views/products/list-products.vue"], resolve),
        meta: {
          title: "Lista de productos",
          permission: "Productos",
          breadcrumb: [
            {
              text: "DashBoard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Lista de productos",
              href: "#/read-products"
            }
          ]
        }
      },
      {
        path: "/precios",
        component: resolve => require(["../views/prices/index.vue"], resolve),
        meta: {
          title: "Mant Precios",
          permission: "Mantenimiento Lista Precios",
          breadcrumb: [
            {
              text: "DashBoard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Precios",
              href: "#/precios"
            }
          ]
        }
      },
      {
        path: "/documentos",
        component: resolve =>
          require(["../views/documents/index.vue"], resolve),
        meta: {
          title: "Documentos",
          permission: "Documentos",
          breadcrumb: [
            {
              text: "DashBoard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Documentos",
              href: "#/documentos"
            }
          ]
        }
      },
      {
        path: "/inventarios",
        component: resolve =>
          require(["../views/inventories/index.vue"], resolve),
        meta: {
          title: "Inventarios",
          breadcrumb: [
            {
              text: "DashBoard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Inventarios",
              href: "#/inventarios"
            }
          ]
        }
      },
      {
        path: "/envio-de-documentos-finalizados",
        component: resolve =>
          require(["../views/send_documents/index.vue"], resolve),
        meta: {
          title: "Documentos Pendientes de Envios (DIAN)",
          breadcrumb: [
            {
              text: "DashBoard",
              href: "#/"
            },
            {
              text: "Documentos Pendientes de Envios (DIAN)",
              href: "#/envio-de-documentos-finalizados"
            }
          ]
        }
      },
      {
        path: "/operaciones",
        component: resolve =>
          require(["../views/types-operation/index.vue"], resolve),
        meta: {
          title: "Operaciones",
          permission: "Tipos de operaciones",
          breadcrumb: [
            {
              text: "DashBoard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Operaciones",
              href: "#/operaciones"
            }
          ]
        }
      },
      {
        path: "/operaciones/crear",
        component: resolve =>
          require(["../views/types-operation/maintenance.vue"], resolve),
        meta: {
          title: "Operaciones",
          permission: "Tipos de operaciones",
          breadcrumb: [
            {
              text: "DashBoard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Operaciones",
              href: "#/operaciones"
            }
          ]
        }
      },
      {
        path: "/operaciones/:idv/ver",
        component: resolve =>
          require(["../views/types-operation/maintenance.vue"], resolve),
        meta: {
          title: "Operaciones",
          permission: "Tipos de operaciones",
          breadcrumb: [
            {
              text: "DashBoard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Operaciones",
              href: "#/operaciones"
            }
          ]
        }
      },
      {
        path: "/operaciones/:id/editar",
        component: resolve =>
          require(["../views/types-operation/maintenance.vue"], resolve),
        meta: {
          title: "Operaciones",
          permission: "Tipos de operaciones",
          breadcrumb: [
            {
              text: "DashBoard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Operaciones",
              href: "#/operaciones"
            }
          ]
        }
      },
      {
        path: "/modelos",
        component: resolve => require(["../views/models/index.vue"], resolve),
        meta: {
          title: "Modelos",
          permission: "Modelos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Modelos",
              href: "#/modelos"
            }
          ]
        }
      },
      {
        path: "/modelos/crear",
        component: resolve =>
          require(["../views/models/modelForm.vue"], resolve),
        meta: {
          title: "Modelos",
          permission: "Modelos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Modelos",
              href: "#/modelos"
            }
          ]
        }
      },
      {
        path: "/modelos/:idv/ver",
        component: resolve =>
          require(["../views/models/modelForm.vue"], resolve),
        meta: {
          title: "Modelos",
          permission: "Modelos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Modelos",
              href: "#/modelos/:idv/ver"
            }
          ]
        }
      },
      {
        path: "/modelos/:id/editar",
        component: resolve =>
          require(["../views/models/modelForm.vue"], resolve),
        meta: {
          title: "Modelos",
          permission: "Modelos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Modelos",
              href: "#/modelos/:id/editar"
            }
          ]
        }
      },
      {
        path: "/reservar-producto",
        component: resolve =>
          require(["../views/reservationProduct/index.vue"], resolve),
        meta: {
          title: "Reservas",
          permission: "Reserva Producto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Reservas",
              href: "#/reservar-producto"
            }
          ]
        }
      },
      {
        path: "/reservar-producto/editar/:id",
        component: resolve =>
          require(["../views/reservationProduct/form.vue"], resolve),
        meta: {
          title: "Reservas",
          permission: "Reserva Producto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Reservas",
              href: "#/reservar-producto/editar/:id"
            }
          ]
        }
      },
      {
        path: "/reservar-producto/crear",
        component: resolve =>
          require(["../views/reservationProduct/form.vue"], resolve),
        meta: {
          title: "Reservas",
          permission: "Reserva Producto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Reservas",
              href: "#/reservar-producto/crear"
            }
          ]
        }
      },
      {
        path: "/solicitud-encabezado",
        component: resolve =>
          require(["../views/request-services/index.vue"], resolve),
        meta: {
          title: "Solicitudes de servicio",
          permission: "Solicitudes de servicio",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Solicitudes de servicio",
              href: "#/solicitud-encabezado"
            }
          ]
        }
      },
      {
        path: "/incorporar-extracto-bancario",
        component: resolve =>
          require(["../views/incorporate-bank-statement/index.vue"], resolve),
        meta: {
          title: "Incorporar Extracto Bancario",
          permission: "Incorporar Extracto Bancario",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Incorporar Extracto Bancario",
              href: "#/incorporar-extracto-bancario"
            }
          ]
        }
      },
      {
        path: "/incorporacion-de-consumos",
        component: resolve =>
          require(["../views/incorporation-consumption/index.vue"], resolve),
        meta: {
          title: "Incorporación de Consumos",
          permission: "Incorporacion de Consumos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Incorporación de Consumos",
              href: "#/incorporacion-de-consumos"
            }
          ]
        }
      },
      {
        path: "/incorporacion-usuarios-consumos",
        component: resolve =>
          require(["../views/incorporation-users-consumption/index.vue"], resolve),
        meta: {
          title: "Incorporacion Usuarios Consumos",
          permission: "Incorporacion Usuarios Consumos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Incorporación de Usuarios",
              href: "#/incorporacion-usuarios-consumos"
            }
          ]
        }
      },
      {
        path: "/informe-de-consumos",
        component: resolve =>
          require(["../views/report-consumption/index.vue"], resolve),
        meta: {
          title: "Informe de Consumos",
          permission: "Informe de Consumos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Informe de Consumos",
              href: "#/informe-de-consumos"
            }
          ]
        }
      },
      {
        path: "/conciliacion-bancaria",
        component: resolve =>
          require(["../reports-aggrid/views/BankConciliation/redirect.vue"], resolve),
        meta: {
          title: "Conciliacion Bancaria",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Reporte de cartera",
              href: "#/conciliacion-bancaria"
            }
          ]
        }
      },
      {
        path: "/solicitud-encabezado/cliente/:cliente",
        component: resolve =>
          require(["../views/request-headers/index.vue"], resolve),
        meta: {
          title: "Solicitudes de servicio",
          permission: "Solicitudes de servicio",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Solicitudes de servicio",
              href: "#/solicitud-encabezado"
            }
          ]
        }
      },
      {
        path: "/solicitud-encabezado/crear",
        component: resolve =>
          require(["../views/request-services/form/index.vue"], resolve),
        meta: {
          title: "Solicitudes de servicio",
          permission: "Solicitudes de servicio",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Solicitudes de servicio",
              href: "#/solicitud-encabezado/crear"
            }
          ]
        }
      },
      {
        path: "/solicitud-encabezado/:id/editar",
        component: resolve =>
          require(["../views/request-services/form/index.vue"], resolve),
        meta: {
          title: "Solicitudes de servicio",
          permission: "Solicitudes de servicio",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Solicitudes de servicio",
              href: "#/solicitud-encabezado/editar"
            }
          ]
        }
      },
      {
        path: "/solicitud-encabezado/:idae/actualizar-estado/:state?",
        component: resolve =>
          require(["../views/request-services/form/index.vue"], resolve),
        meta: {
          title: "Solicitudes de servicio",
          permission: "Solicitudes de servicio",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Solicitudes de servicio",
              href: "#/solicitud-encabezado/editar"
            }
          ]
        }
      },
      {
        path: "/solicitud-encabezado/:idin/ingresar",
        component: resolve =>
          require(["../views/request-services/form/index.vue"], resolve),
        meta: {
          title: "Solicitudes de servicio",
          permission: "Solicitudes de servicio",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Solicitudes de servicio",
              href: "#/solicitud-encabezado/editar"
            }
          ]
        }
      },
      {
        path: "/solicitud-encabezado/:idtd/tras-a-disp",
        component: resolve =>
          require(["../views/request-services/form/index.vue"], resolve),
        meta: {
          title: "Solicitudes de servicio",
          permission: "Solicitudes de servicio",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Solicitudes de servicio",
              href: "#/solicitud-encabezado/editar"
            }
          ]
        }
      },
      {
        path: "/solicitud-encabezado/:idv/ver",
        component: resolve =>
          require(["../views/request-products/index.vue"], resolve),
        meta: {
          title: "Solicitudes de servicio",
          permission: "Solicitudes de servicio",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Solicitudes de servicio",
              href: "#/solicitud-encabezado/:idv/ver"
            }
          ]
        }
      },
      {
        path: "/movimientos/:model_id_create/crear",
        component: resolve =>
          require(["../views/inventory-movements/maintenance.vue"], resolve),
        meta: {
          title: "",
          function_execute: async model_id_create => {
            let model = JSON.parse(localStorage.getItem("selectedModel"));

            if (!model || +model.id !== +model_id_create) {
              await $http
                .get("/api/modelos/" + model_id_create)
                .then(response => {
                  model = response.data.data;
                  localStorage.setItem("selectedModel", JSON.stringify(model));
                });
            }

            return model.code + " " + model.description;
          },
          parameter: "model_id_create",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Facturacion",
              href: "#/movimiento-inventario"
            }
          ]
        }
      },
      {
        path: "/movimientos/:model_id_view/:document_id_view/ver",
        component: resolve =>
          require(["../views/inventory-movements/maintenance.vue"], resolve),
        meta: {
          title: "",
          function_execute: async model_id_view => {
            let model = JSON.parse(localStorage.getItem("selectedModel"));

            if (!model || +model.id !== +model_id_view) {
              await $http
                .get("/api/modelos/" + model_id_view)
                .then(response => {
                  model = response.data.data;
                  localStorage.setItem("selectedModel", JSON.stringify(model));
                });
            }

            return model.code + " " + model.description;
          },
          parameter: "model_id_view",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Movimientos de inventario",
              href: "#/movimiento-inventario"
            }
          ]
        }
      },
      {
        path: "/movimientos/:model_id_update/:document_id_update/actualizar",
        component: resolve =>
          require(["../views/inventory-movements/maintenance.vue"], resolve),
        meta: {
          title: "",
          function_execute: async model_id_update => {
            let model = JSON.parse(localStorage.getItem("selectedModel"));

            if (!model || +model.id !== +model_id_update) {
              await $http
                .get("/api/modelos/" + model_id_update)
                .then(response => {
                  model = response.data.data;
                  localStorage.setItem("selectedModel", JSON.stringify(model));
                });
            }
            return model.code + " " + model.description;
          },
          parameter: "model_id_update",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Movimientos de inventario",
              href: "#/movimiento-inventario"
            }
          ]
        }
      },
      {
        path:
          "/movimientos/:model_id_update_doc/:document_id/actualizar/documento",
        component: resolve =>
          require(["../views/inventory-movements/maintenance.vue"], resolve),
        meta: {
          title: "",
          function_execute: async model_id_update_doc => {
            let model = JSON.parse(localStorage.getItem("selectedModel"));

            if (!model || +model.id !== +model_id_update_doc) {
              await $http
                .get("/api/modelos/" + model_id_update_doc)
                .then(response => {
                  model = response.data.data;
                  localStorage.setItem("selectedModel", JSON.stringify(model));
                });
            }
            return model.code + " " + model.description;
          },
          parameter: "model_id_update_doc",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Movimientos de inventario",
              href: "#/movimiento-inventario"
            }
          ]
        }
      },
      {
        path: "/movimientos/:model_id/:document_id",
        component: resolve =>
          require(["../views/inventory-movements/maintenance.vue"], resolve),
        meta: {
          title: "",
          function_execute: async model_id => {
            let model = JSON.parse(localStorage.getItem("selectedModel"));

            if (!model || +model.id !== +model_id) {
              await $http.get("/api/modelos/" + model_id).then(response => {
                model = response.data.data;
                localStorage.setItem("selectedModel", JSON.stringify(model));
              });
            }
            return model.code + " " + model.description;
          },
          parameter: "model_id",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Movimientos de inventario",
              href: "#/movimiento-inventario"
            }
          ]
        }
      },
      {
        path: "/movimientos/:model_id",
        component: resolve =>
          require(["../views/inventory-movements/maintenance.vue"], resolve),
        meta: {
          title: "",
          function_execute: async model_id => {
            let model = JSON.parse(localStorage.getItem("selectedModel"));

            if (!model || +model.id !== +model_id) {
              await $http.get("/api/modelos/" + model_id).then(response => {
                model = response.data.data;
                localStorage.setItem("selectedModel", JSON.stringify(model));
              });
            }
            return model.code + " " + model.description;
          },
          parameter: "model_id",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Facturacion",
              href: "#/movimiento-inventario"
            }
          ]
        }
      },
      /**
       * Estas rutas van relacionadas al
       * modulo de pedidos retenidos
       *
       * @author Kevin Galindo
       */
      {
        path: "/pedidos-retenidos/",
        component: resolve =>
          require(["../views/orders_retained/Index.vue"], resolve),
        meta: {
          title: "Pedidos retenidos",
          permission: "Pedidos Retenidos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "pedidos-retenidos",
              href: "#/pedidos-retenidos"
            }
          ]
        }
      },
      /**
       * modulo de despachos
       * @author Kevin Galindo
       */
      {
        path: "/despachos",
        component: resolve => require(["../views/despatch/Index.vue"], resolve),
        meta: {
          title: "Despachos",
          permission: "Despachos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Despachos",
              href: "#/despachos"
            }
          ]
        }
      },
        {
            path: '/despachos-packing',
            component: resolve => require(['../views/despatch-packing/index.vue'], resolve),
            meta: {
                title: 'Despachos Packing',
                permission: 'Despachos',
                breadcrumb: [
                    {
                        text: ' Dashboard',
                        href: '#/'
                    },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Despachos Packing',
                        href: '#/despachos-packing'
                    }
                ]
            }
        },
      {
        path: "/buscar-documentos",
        component: resolve =>
          require([
            "../views/inventory-movements/ListDocumentGlobal.vue"
          ], resolve),
        meta: {
          title: "Buscar Documentos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Buscar Documentos",
              href: "#/buscar-documentos"
            }
          ]
        }
      },
      {
        path: "/buscar-documentos-masivo",
        component: resolve =>
          require([
            "../views/inventory-movements/ListDocumentGlobalMasive.vue"
          ], resolve),
        meta: {
          title: "Impresion Masiva Documentos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Impresion Masiva Documentos",
              href: "#/buscar-documentos-masivo"
            }
          ]
        }
      },
      {
        path: "/masivo-correos-cliente",
        component: resolve =>
          require([
            "../views/masive-mails/ListDocumentGlobalMasive.vue"
          ], resolve),
        meta: {
          title: "Envio Masivo Cartera",
          permission: "Envio Masivo Cartera",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Envio Masivo Cartera",
              href: "#/buscar-documentos-masivo"
            }
          ]
        }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/comprobantes",
        component: resolve =>
          require(["../views/various-vouchers/index.vue"], resolve),
        meta: {
          title: "Comprobantes Contables",
          permission: "Comprobantes Contables",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      {
        path: "/comprobantes/:id",
        component: resolve =>
          require(["../views/various-vouchers/index.vue"], resolve),
        meta: {
          title: "Comprobantes Contables",
          permission: "Comprobantes Contables",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/libro-auxiliar",
        component: resolve =>
          require(["../views/auxiliary-book/index.vue"], resolve),
        meta: {
          title: "Libro Auxiliar",
          permission: "libroAuxiliar",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/comparativo-de-cuentas",
        component: resolve =>
          require(["../views/account-comparison/index.vue"], resolve),
        meta: {
          title: "Comparativo de Cuentas",
          permission: "Comparativo de Cuentas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            }
          ]
        }
      },
      /**
       *
       * @author Hom669
       */
      {
        path: "/trial-balance",
        component: resolve =>
          require(["../views/trial-balance/index.vue"], resolve),
        meta: {
          title: "Balance de Prueba",
          permission: "balancePrueba",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      {
        path: "/trial-balance-contact",
        component: resolve =>
          require(["../views/trial-balance-contact/index.vue"], resolve),
        meta: {
          title: "Balance de Prueba por Tercero",
          permission: "balancePruebaTercero",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Hom669
       */
      {
        path: "/estados-financieros",
        component: resolve =>
          require(["../views/estados-financieros/index.vue"], resolve),
        meta: {
          title: "Estados Financieros Por Mes",
          permission: "estadoFinanciero",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },

      /**
       *
       * @author Santiago
       */
      {
        path: "/movimientos-cuenta-tercero",
        component: resolve =>
          //window.open('/#/reportes/libro-auxiliar-tercero','_blank'),
          require(["../views/movements-account-contact/index.vue"], resolve),
        meta: {
          title: "Movimientos cuenta tercero",
          permission: "Movimientos cuenta tercero",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/libro-auxiliar-por-tercero",
        component: resolve =>
          //window.open('/#/reportes/libro-auxiliar-tercero','_blank'),
          require(["../views/auxiliary-book-contact/index.vue"], resolve),
        meta: {
          title: "Libro Auxiliar por Tercero",
          permission: "libroAuxiliarTerceero",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Hom669
       */
      {
        path: "/reporte-comisiones",
        component: resolve =>
          //window.open('/#/reportes/libro-auxiliar-tercero','_blank'),
          require(["../views/report-commisions/index.vue"], resolve),
        meta: {
          title: "Informe de Recaudo",
          permission: "Informe de Recaudo",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Hom669
       */
      {
        path: "/reporte-bo/:id_seller?/:id_contact?",
        component: resolve =>
          require(["../views/report-bo/index.vue"], resolve),
        meta: {
          title: "Reporte BO",
          permission: "Reporte BO",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Hom669
       */
      {
        path: "/conciliacion-saldos",
        component: resolve =>
          //window.open('/#/reportes/libro-auxiliar-tercero','_blank'),
          require(["../views/conciliation-balances/index.vue"], resolve),
        meta: {
          title: "Conciliación de Saldos WMS",
          permission: "Conciliacion Saldos WMS",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },

      /**
       *
       * @author Hom669
       */
      {
        path: "/cargue-transportadora-guia",
        component: resolve =>
          //window.open('/#/reportes/libro-auxiliar-tercero','_blank'),
          require(["../views/protractor-guide/index.vue"], resolve),
        meta: {
          title: "Cargue Transportadora y Guia",
          permission: "Cargue Transportadora y Guia",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Hom669
       */
      {
        path: "/actualizacion-precios-contacto",
        component: resolve =>
          //window.open('/#/reportes/libro-auxiliar-tercero','_blank'),
          require(["../views/prices-contacts/index.vue"], resolve),
        meta: {
          title: "Actualizacion Precios Por Tercero",
          permission: "Actualizacion Precios Por Tercero",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/cuentas",
        component: resolve => require(["../views/accounts/index.vue"], resolve),
        meta: {
          title: "Plan de Cuentas",
          permission: "PlanCuentas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/job",
        component: resolve =>
          require(["../views/star-jobs/index.vue"], resolve),
        meta: {
          title: "Job",
          permission: "Jobs",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/job/:id",
        component: resolve =>
          require(["../views/star-jobs/index.vue"], resolve),
        meta: {
          title: "Job",
          permission: "Jobs",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      {
          path: "/recepcion-documentos",
          component: resolve =>
              require(["../views/reception_documents/index.vue"], resolve),
          meta: {
              title: "Recepción de documentos",
              // permission: "Recepción de documentos",
              breadcrumb: [
                  {
                      text: " Dashboard",
                      href: "#/"
                  },
                  {
                      text: "Administración Starcommerce",
                      href: "#"
                  },
                  {
                      text: "Recepción de documentos",
                      href: "#/recepcion-documentos"
                  }
              ]
          }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/Aurora",
        component: resolve => require(["../views/Aurora/index.vue"], resolve),
        meta: {
          title: "Aurora",
          permission: "aurora",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/cuentas/crear",
        component: resolve =>
          require(["../views/accounts/maintenance.vue"], resolve),
        meta: {
          title: "Plan de Cuentas",
          permission: "PlanCuentas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/cuentas/:id_clone/clonar",
        component: resolve =>
          require(["../views/accounts/maintenance.vue"], resolve),
        meta: {
          title: "Plan de Cuentas",
          permission: "PlanCuentas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/cuentas/:id_edit/editar",
        component: resolve =>
          require(["../views/accounts/maintenance.vue"], resolve),
        meta: {
          title: "Plan de Cuentas",
          permission: "PlanCuentas",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/traslado/:id/ver",
        component: resolve => require(["../views/transfer/index.vue"], resolve),
        meta: {
          title: "Traslado",
          permission: "Traslados",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      /**
       *
       * @author Santiago
       */
      {
        path: "/borrar-erp/",
        component: resolve =>
          require(["../views/clear-erp/index.vue"], resolve),
        meta: {
          title: "Borrar erp",
          permission: "BorrarErp",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      // /**
      //  *
      //  * @author Santiago
      //  */
      // {
      //   path: "/traslado/:ide/editar",
      //   component: resolve => require(["../views/transfer/index.vue"], resolve),
      //   meta: {
      //     title: "Traslado",
      //     permission: "Traslados",
      //     breadcrumb: [
      //       {
      //         text: " Dashboard",
      //         href: "#/"
      //       },
      //       {
      //         text: "Administración Starcommerce",
      //         href: "#"
      //       },
      //       {
      //         text: "Sistema de inventarios",
      //         href: "#/traslado"
      //       }
      //     ]
      //   }
      // },
      // /**
      //  *
      //  * @author Santiago
      //  */
      {
        path: "/traslado",
        component: resolve => require(["../views/transfer/index.vue"], resolve),
        meta: {
          title: "Traslado",
          permission: "Traslados",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      {
        path: "/reporte-clientes-prospecto",
        component: resolve => require(["../views/report-prospective-client/index.vue"], resolve),
        meta: {
          title: "Reporte clientes prospecto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Reporte clientes prospecto",
              href: "#/reporte-clientes-prospecto"
            }
          ]
        }
      },
      {
        path: "/reporte",
        component: resolve => require(["../views/report/index.vue"], resolve),
        meta: {
          title: "Matriz dinámica",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Matriz dinámica",
              href: "#/reporte"
            }
          ]
        }
      },
      /**
       *
       * @author Hom669
       */
      {
        path: "/reporte-bo/:id_seller?/:id_contact?",
        component: resolve =>
          //window.open('/#/reportes/libro-auxiliar-tercero','_blank'),
          require(["../views/report-bo/index.vue"], resolve),
        meta: {
          title: "Reporte BO",
          permission: "Reporte BO",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Reporte BO",
              href: "#/reporte-bo"
            }
          ]
        }
      },
      {
        path: "/detalle-de-ventas",
        component: resolve =>
            require(["../views/sales-detail/index.vue"], resolve),
        meta: {
          title: "Reporte de Ventas Analitrix",
          permission: "Reporte de Ventas Analitrix",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Reporte de Ventas Analitrix",
              href: "#/detalle-de-ventas"
            }
          ]
        }
      },
        {
            path: "/detalle-de-ventas-dashboard",
            component: resolve => require(["../views/sales-report/index.vue"], resolve),
            meta: {
                title: "Detalle de ventas - Dashboard",
                permission: "Detalle de ventas",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Detalle de ventas - Dashboard",
                        href: "#/detalle-de-ventas"
                    }
                ]
            }
        },
      {
        path: "/reporte-de-cartera",
        component: resolve =>
          require(["../views/receivable/index.vue"], resolve),
        meta: {
          title: "Reporte de cartera",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Reporte de cartera",
              href: "#/reporte-de-cartera"
            }
          ]
        }
      },
        {
            path: '/proceso-de-pagos',
            component: resolve =>
                require(['../views/receivable/index_pp.vue'], resolve),
            meta: {
                title: 'Proceso de Pago',
                breadcrumb: [
                    {
                        text: ' Dashboard',
                        href: '#/'
                    },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Proceso de Pago',
                        href: '#/proceso-de-pagos'
                    }
                ]
            }
        },
        {
            path: '/municipios-ciudades',
            component: resolve =>
                require(['../views/municipalities-cities/index.vue'], resolve),
            meta: {
                title: 'Municipios y Ciudades',
                breadcrumb: [
                    {
                        text: ' Dashboard',
                        href: '#/'
                    },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Municipios y Ciudades',
                        href: '#/proceso-de-pagos'
                    }
                ]
            }
        },
        {
            path: '/comisiones-venta-marca',
            component: resolve =>
                require(['../views/commission-sale-brand/index.vue'], resolve),
            meta: {
                title: 'Comisiones x Venta x Marca',
                breadcrumb: [
                    {
                        text: ' Dashboard',
                        href: '#/'
                    },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Comisiones x Venta x Marca',
                        href: '#/comisiones-venta-marca'
                    }
                ]
            }
        },
      /**
       *
       * @author Daniel Grisales
       */
      {
        path: "/reporte-inventario",
        component: resolve =>
          require(["../views/report-ir/index.vue"], resolve),
        meta: {
          title: "Reporte de Reposición de Inventario",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Reporte de Reposición de Inventario",
              href: "#/reporte-inventario"
            }
          ]
        }
      },
      /**
       *
       * @author Daniel Grisales
       */
      {
        path: "/movimientos-proyecto",
        component: resolve =>
          require(["../views/project-movements/index.vue"], resolve),
        meta: {
          title: "Movimientos por Proyecto",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Movimientos por Proyecto",
              href: "#/movimientos-proyecto"
            }
          ]
        }
      },
        {
            path: "/historico-por-documento",
            component: resolve =>
                require(["../views/historical-by-document/index.vue"], resolve),
            meta: {
                title: "Historico Por Documento",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Historico Por Documento",
                        href: "#/historico-por-documento"
                    }
                ]
            }
        },
      {
        path: "/saldos-contables",
        component: resolve => require(["../views/account-balance/index.vue"], resolve),
        meta: {
          title: "Saldos Contables",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Saldos Contables",
              href: "#/saldos-contables"
            }
          ]
        }
      },
      {
        path: "/actualizacion-masiva-saldos",
        component: resolve =>
          require(["../views/update_balances/index.vue"], resolve),
        meta: {
          title: "Actualización masiva de saldos",
          permission: "Actualización masiva de saldos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Actualización masiva de saldos",
              href: "#/actualizacion-masiva-saldos"
            }
          ]
        }
      },
      {
        path: "/traslado-rot/:id/ver",
        component: resolve =>
          require(["../views/transfer-rot/index.vue"], resolve),
        meta: {
          title: "Traslado Rot Gar",
          permission: "Traslados",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      {
        path: "/traslado-rot",
        component: resolve =>
          require(["../views/transfer-rot/index.vue"], resolve),
        meta: {
          title: "Traslado Rot Gar",
          permission: "Traslados",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/traslado"
            }
          ]
        }
      },
      {
        path: "/kardex",
        component: resolve => require(["../views/kardex/index.vue"], resolve),
        meta: {
          title: "kardex",
          permission: "Kardex",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/kardex"
            }
          ]
        }
      },
      {
        path: "/kardex-consolidado",
        component: resolve => require(["../views/consolidated_kardex/index.vue"], resolve),
        meta: {
          title: "Kardex consolidado",
          permission: "Kardex consolidado",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/kardex-consolidado"
            }
          ]
        }
      },
      {
        path: "/detencion-inconsistencias",
        component: resolve => require(["../views/discount-inconsistencies/index.vue"], resolve),
        meta: {
          title: "Detencion de Inconsistencias",
          permission: "Detencion de Inconsistencias",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/Detencion de Inconsistencias"
            }
          ]
        }
      },
      {
        path: "/Descuentos",
        component: resolve =>
          require(["../views/discounts/index.vue"], resolve),
        meta: {
          title: "Descuentos",
          permission: "Descuentos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/Descuentos"
            }
          ]
        }
      },
      {
        path: "/detencion-inconsistencias",
        component: resolve => require(["../views/discount-inconsistencies/index.vue"], resolve),
        meta: {
          title: "Detencion de Inconsistencias",
          permission: "Detencion de Inconsistencias",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/Detencion de Inconsistencias"
            }
          ]
        }
      },
      {
        path: "/Descuentos/crear",
        component: resolve => require(["../views/discounts/form.vue"], resolve),
        meta: {
          title: "Crear Descuentos",
          permission: "Descuentos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/Descuentos/crear"
            }
          ]
        }
      },
      {
        path: "/Descuentos/:id/editar",
        component: resolve => require(["../views/discounts/form.vue"], resolve),
        meta: {
          title: "Editar Descuentos",
          permission: "Descuentos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/Descuentos/:id/editar"
            }
          ]
        }
      },
      // CustomerDiscountBrandAPIController
      {
        path: "/descuentos-por-cliente-marca",
        component: resolve =>
          require(["../views/customerDiscountBrand/index.vue"], resolve),
        meta: {
          title: "Descuentos Por Cliente Marca",
          permission: "Descuentos Por Cliente Marca",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Descuentos Por Cliente Marca",
              href: "#/Descuentos Por Cliente Marca"
            }
          ]
        }
      },
      {
        path: "/descuentos-por-cliente-marca/crear",
        component: resolve => require(["../views/customerDiscountBrand/form.vue"], resolve),
        meta: {
          title: "Crear Descuento Por Cliente Marca",
          permission: "Descuentos Por Cliente Marca",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Crear Descuento Por Cliente Marca",
              href: "#/descuentos-por-cliente-marca/crear"
            }
          ]
        }
      },
      {
        path: "/descuentos-por-cliente-marca/:id/editar",
        component: resolve => require(["../views/customerDiscountBrand/form.vue"], resolve),
        meta: {
          title: "Editar Descuento Por Cliente Marca",
          permission: "Descuentos Por Cliente Marca",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Editar Descuento Por Cliente Marca",
              href: "#/descuentos-por-cliente-marca/:id/editar"
            }
          ]
        }
      },
      {
        path: "/Descuentos-Pronto-Pago",
        component: resolve =>
          require(["../views/discounts-soon-payment/index.vue"], resolve),
        meta: {
          title: "Descuentos-Pronto-Pago",
          permission: "Descuentos pronto pago",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/Descuentos-Pronto-Pago"
            }
          ]
        }
      },
      {
        path: "/Descuentos-Pronto-Pago/crear",
        component: resolve =>
          require(["../views/discounts-soon-payment/form.vue"], resolve),
        meta: {
          title: "Crear Descuentos Pronto Pago",
          permission: "Descuentos pronto pago",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/Descuentos-Pronto-Pago/crear"
            }
          ]
        }
      },
      {
        path: "/Descuentos-Pronto-Pago/:id/editar",
        component: resolve =>
          require(["../views/discounts-soon-payment/form.vue"], resolve),
        meta: {
          title: "Editar Descuentos",
          permission: "Descuentos pronto pago",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/Descuentos-Pronto-Pago/:id/editar"
            }
          ]
        }
      },

      {
        path: "/Informe-Operaciones-Rango-Fecha",
        component: resolve =>
          require(["../views/operations-report/index.vue"], resolve),
        meta: {
          title: "Informe Operaciones Rango Fecha",
          permission: "Informe Operaciones Rango Fecha",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/Descuentos-Pronto-Pago/:id/editar"
            }
          ]
        }
      },

      {
        path: "/consulta-disponibilidad",
        component: resolve =>
          require(["../views/availability-inquiry/index.vue"], resolve),
        meta: {
          title: "Consulta Disponibilidad",
          permission: "Consulta Disponibilidad",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/Descuentos-Pronto-Pago/:id/editar"
            }
          ]
        }
      },

      {
        path: "/reconstructor-global",
        component: resolve =>
          require(["../views/rebuilder/index.vue"], resolve),
        meta: {
          title: "Reconstructor",
          permission: "Reconstructor",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/Descuentos-Pronto-Pago/:id/editar"
            }
          ]
        }
      },
      {
        path: "/informe-inventario",
        component: resolve =>
          require(["../views/inventory-report/index.vue"], resolve),
        meta: {
          title: "Inventario valorizado",
          permission: "Inventario valorizado",
          breadcrumb: [
            {
              text: "Informes",
              href: "#/"
            },
            {
              text: "Inventario valorizado",
              href: "#"
            }
          ]
        }
      },
      {
        path: "/sugerido-de-reposicion",
        component: resolve =>
          require(["../views/suggested_replacement/index.vue"], resolve),
        meta: {
          title: "Sugerido de Reposición",
          permission: "Sugerido de Reposición",
          breadcrumb: [
            {
              text: "Informes",
              href: "#/"
            },
            {
              text: "Sugerido de Reposición",
              href: "#"
            }
          ]
        }
      },
      {
        path: "/business_intelligence",
        component: resolve =>
          require(["../views/business_intelligence/index.vue"], resolve),
        meta: {
          title: "Business Intelligence",
          permission: "Business Intelligence",
          breadcrumb: [
            {
              text: "Informes",
              href: "#/"
            },
            {
              text: "Business Intelligence",
              href: "#"
            }
          ]
        }
      },
        //  informe usuarios
      {
        path: "/informe-usuarios",
        component: resolve =>
          require(["../views/inventory-users/index.vue"], resolve),
        meta: {
          title: "Informe Terceros",
          permission: "Informe Terceros",
          breadcrumb: [
            {
              text: "Informes",
              href: "#/"
            },
            {
              text: "Inventario Terceros",
              href: "#"
            }
          ]
        }
      },
      {
        path: "/b2b/pedidos",
        component: resolve =>
          require(["../views/ordersManagement/index.vue"], resolve),
        meta: {
          title: "Gestión pedidos",
          permission: "Gestión de pedidos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Gestión pedidos",
              href: "/b2b/pedidos"
            }
          ]
        }
      },
      {
        path: "/b2b/promociones",
        component: resolve =>
          require(["../views/cashReceipts/index.vue"], resolve),
        meta: {
          title: "Recibos de caja",
          permission: "Recibos de caja",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "B2B",
              href: "#"
            },
            {
              text: "Recibos de caja",
              href: "/b2b/promociones"
            }
          ]
        }
      },
      {
        path: "/formas-pago",
        component: resolve =>
          require(["../views/payment-methods/index.vue"], resolve),
        meta: {
          title: "Formas de Pago",
          permission: "Formas de pago",
          breadcrumb: []
        }
      },
      {
        path: "/formas-pago/:idv/ver",
        component: resolve =>
          require(["../views/payment-methods/form.vue"], resolve),
        meta: {
          title: "Formas de Pago",
          permission: "Formas de pago",
          breadcrumb: []
        }
      },
      {
        path: "/formas-pago/:id/editar",
        component: resolve =>
          require(["../views/payment-methods/form.vue"], resolve),
        meta: {
          title: "Formas de Pago",
          permission: "Formas de pago",
          breadcrumb: []
        }
      },
      {
        path: "/formas-pago/crear",
        component: resolve =>
          require(["../views/payment-methods/form.vue"], resolve),
        meta: {
          title: "Formas de Pago",
          permission: "Formas de pago",
          breadcrumb: []
        }
      },
      {
        path: "/estado-cuenta",
        component: resolve =>
          require(["../views/customer_account_statement/index.vue"], resolve),
        meta: {
          title: "Estado Cuenta Cliente",
          permission: "Estado Cuenta",
          breadcrumb: []
        }
      },
      {
        path: "/certificado-retenciones",
        component: resolve =>
          require(["../views/certificates_retentions/index.vue"], resolve),
        meta: {
          title: "Certificados de Retenciones",
          permission: "Certificados de Retenciones",
          breadcrumb: []
        }
      },
      {
        path: "/factura-detalle/:id",
        component: resolve =>
          require(["../views/invoice_detail/index.vue"], resolve),
        meta: {
          title: "Detalle factura",
          permission: "Detalle factura",
          breadcrumb: []
        }
      },
      {
        path: "/cuadre-de-caja",
        component: resolve =>
          require(["../views/cash-register-square/Index.vue"], resolve),
        meta: {
          title: "Cuadre de Caja",
          permission: "",
          breadcrumb: []
        }
      },
      {
        path: "/cruce-de-saldos",
        component: resolve =>
          require(["../views/balance-crossing/index.vue"], resolve),
        meta: {
          title: "Cruce de Saldos",
          permission: "",
          breadcrumb: []
        }
      },
      {
        path: "/cruce-de-saldos/:id",
        component: resolve =>
          require(["../views/balance-crossing/index.vue"], resolve),
        meta: {
          title: "Cruce de Saldos",
          permission: "",
          breadcrumb: []
        }
      },
      {
        path: "/reasignacion-vendedor",
        component: resolve =>
          require(["../views/reassign_seller/index.vue"], resolve),
        meta: {
          title: "Reasignacion Vendedor",
          permission: "Reasignacion Vendedor",
          breadcrumb: []
        }
      },
      {
        path: "/auditoria/:id",
        component: resolve => require(["../views/audit/index.vue"], resolve),
        meta: {
          title: "Auditoria Factura",
          breadcrumb: []
        }
      },
      // SellingPricesAboveCostAPIController
      {
        path: "/precio-venta-sobre-costo",
        component: resolve =>
          require(["../views/selling-prices-above-cost/index.vue"], resolve),
        meta: {
          title: "Precio venta sobre costo",
          permission: "Precio venta sobre costo",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/precio-venta-sobre-costo"
            }
          ]
        }
      },
      {
        path: "/precio-venta-sobre-costo/crear",
        component: resolve =>
          require(["../views/selling-prices-above-cost/form.vue"], resolve),
        meta: {
          title: "Crear precio venta sobre costo",
          permission: "Precio venta sobre costo",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/precio-venta-sobre-costo/crear"
            }
          ]
        }
      },
      {
        path: "/precio-venta-sobre-costo/:id/editar",
        component: resolve =>
          require(["../views/selling-prices-above-cost/form.vue"], resolve),
        meta: {
          title: "Editar precio venta sobre costo",
          permission: "Precio venta sobre costo",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Sistema de inventarios",
              href: "#/precio-venta-sobre-costo/:id/editar"
            }
          ]
        }
      },
      {
        path: '/agenda',
        component: resolve => require(['../views/schedule/index.vue'], resolve),
        meta: {
          title: 'Agenda',
          permission: 'Agenda',
          breadcrumb: [{
            text: ' Dashboard',
            href: '#/'
          },
            {
              text: 'Administración Starcommerce',
              href: '#'
            },
            {
              text: 'Agenda',
              href: '#/agenda'
            }
          ]
        }
      },
        {
            path: '/punto-de-venta',
            component: resolve => require(['../views/point_of_sale/index.vue'], resolve),
            meta: {
                title: 'Punto de venta',
                permission: 'Punto de venta',
                breadcrumb: [{
                    text: ' Dashboard',
                    href: '#/'
                },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Punto de venta',
                        href: '#/punto-de-venta'
                    }
                ]
            }
        },
        {
            path: '/incorporar-operaciones-inventario',
            component: resolve => require(['../views/incorporate_inventory_operations/index.vue'], resolve),
            meta: {
                title: 'Importar operaciones de inventario',
                permission: 'Importar operaciones de inventario',
                breadcrumb: [{
                    text: ' Dashboard',
                    href: '#/'
                },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Importar operaciones de inventario',
                        href: '#/incorporar-operaciones-inventario'
                    }
                ]
            }
        },
        {
            path: '/incorporar-saldos-iniciales-inventario',
            component: resolve => require(['../views/inventory-initial-balance/index'], resolve),
            meta: {
                title: 'Importar Saldos Iniciales de Inventario',
                permission: 'Importar Saldos Iniciales de Inventario',
                breadcrumb: [{
                    text: ' Dashboard',
                    href: '#/'
                },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Importar Saldos Iniciales de Inventario',
                        href: '#/incorporar-saldos-iniciales-inventario'
                    }
                ]
            }
        },
        {
            path: "/reporte-ventas-compras",
            component: resolve =>
                //window.open('/#/reportes/libro-auxiliar-tercero','_blank'),
                require(["../views/report-sales-purchases/index.vue"], resolve),
            meta: {
                title: "Informe de compras-ventas",
                permission: "Informe de compras-ventas",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    }
                ]
            }
        },
        {
          path: "/actualizar-retenciones",
          component: resolve => require(["../views/update-withholdings/index.vue"], resolve),
          meta: {
              title: "Actualizar retenciones",
              permission: "Actualizar retenciones",
              breadcrumb: [
                  {
                      text: " Dashboard",
                      href: "#/"
                  },
                  {
                      text: "Administración Starcommerce",
                      href: "#"
                  },
                  {
                      text: "Actualizar retenciones",
                      href: "#/actualizar-retenciones"
                  }
              ]
          }
      },
        {
            path: "/estado-cuenta-proveedor",
            component: resolve =>
                require(["../views/provider_account_statement/index.vue"], resolve),
                meta: {
                  title: "Estado Cuenta Proveedor",
                  permission: "Estado Cuenta Proveedor",
                  breadcrumb: []
                }
        },
        {
            path: "/libro-diario",
            component: resolve =>
                require(["../views/accounting-detail-document/index.vue"], resolve),
            meta: {
                title: "Libro Diario",
                permission: "Libro Diario",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Libro Diario",
                        href: "#/libro-diario"
                    }
                  ]
            }
        },
        {
            path: "/reporte-comisiones-recaudo",
            component: resolve =>
                //window.open('/#/reportes/libro-auxiliar-tercero','_blank'),
                require(["../views/report-commisions-collection/index.vue"], resolve),
            meta: {
                title: "Informe de Comisiones por Recaudo",
                permission: "Informe de Comisiones por Recaudo",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Informe de Comisiones por Recaudo",
                        href: "#/reporte-comisiones-recaudo"
                    }
                ]
            }
        },
        {
            path: "/integracion-b2c",
            component: resolve =>
                //window.open('/#/reportes/libro-auxiliar-tercero','_blank'),
                require(["../views/b2c_integration/index.vue"], resolve),
            meta: {
                title: "Integración B2C",
                permission: "Integración B2C",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Integración B2C",
                        href: "#/integracion-b2c"
                    }
                ]
            }
        },
        {
            path: "/limpieza-informacion",
            component: resolve => require(["../views/delete-documents/index.vue"], resolve),
            meta: {
                title: "Modulo Limpieza de Información",
                permission: "Modulo Limpieza de Informacion",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Modulo Limpieza de Información",
                        href: "#/limpieza-informacion"
                    }
                ]

            }
        },
        {
            path: "/modificar-documentos-inventario/:id?",
            component: resolve =>
                require(["../views/manage-inventory-documents/index.vue"], resolve),
            meta: {
                title: "Modificacion Documentos Inventario",
                permission: "Modificacion Documentos Inventario",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Modificacion Documentos Inventario",
                        href: "#/modificar-documentos-inventario"
                    }
                ]
            }
        },
        {
            path: '/reporte-conciliacion-inventario',
            component: resolve => require(['../views/inventory-reconciliation/index.vue'], resolve),
            meta: {
                title: 'Conciliación Inventario',
                permission: 'Conciliacion Inventario',
                breadcrumb: []
            }
        },
        {
            path: "/incorporar-plan-cuentas",
            component: resolve =>
                //window.open('/#/reportes/libro-auxiliar-tercero','_blank'),
                require(["../views/import-accounts-plans/index.vue"], resolve),

            meta: {
                title: "Incorporar Plan de Cuentas",
                permission: "Incorporar Plan de Cuentas",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Incorporar Plan de Cuentas",
                        href: "#/incorporar-plan-cuentas"
                    }
                    ]
            }
        },
        {
            path: "/reporte-resultado-integral-eri",
            component: resolve => require(["../views/result-report-eri/index.vue"], resolve),
            meta: {
                title: "Estado de resultado Integral ERI",
                permission: "Estado de resultado integral ERI",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Estado de resultado integral ERI",
                        href: "#/reporte-resultado-integral-eri"
                    }
                    ]
            }
        },
        {
            path: '/incorporar-movimientos-contables',
            component: resolve => require(['../views/incorporate_accounting_movements/index.vue'], resolve),
            meta: {
                title: 'Incorporar movimientos contables',
                permission: 'Incorporar movimientos contables',
                breadcrumb: [{
                    text: ' Dashboard',
                    href: '#/'
                },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Incorporar movimientos contables',
                        href: '#/incorporar-movimientos-contables'
                    }
                ]
            }
        },
        {

            path: '/reporte-saldos-por-tercero',
            component: resolve => require(['../views/balance-for-contacts/index'], resolve),
            meta: {
                title: 'Informe De Saldos Por Tercero',
                permission: 'Informe De Saldos Por Tercero',
                breadcrumb: [
                    {
                        text: ' Dashboard',
                        href: '#/'
                    },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {

                        text: 'Informe De Saldos Por Tercero',
                        href: '#/reporte-saldos-por-tercero'
                    }
                ]
            }
        },
        {
            path: '/proceso-acondicionamiento',
            component: resolve =>
                require(['../views/conditioning/index'], resolve),
            meta: {
                title: 'Ordenes de producción',
                permission: 'Ordenes de producción',
                breadcrumb: [
                    {
                        text: ' Dashboard',
                        href: '#/'
                    },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Ordenes de producción',
                        href: '#/proceso-acondicionamiento'
                    }
                ]
            }
        },
        {
            path: '/orden-produccion/:id?',
            component: resolve =>
                require(['../views/conditioning/production_order'], resolve),
            meta: {
                title: 'Ordenes de producción',
                permission: 'Ordenes de producción',
                breadcrumb: [
                    {
                        text: ' Dashboard',
                        href: '#/'
                    },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Orden de producción',
                        href: '#/orden-produccion'
                    }
                ]
            }
        },
        {
            path: '/reporte-pharex',
            component: resolve => require(['../views/report-pharex/index.vue'], resolve),
            meta: {
                title: 'Reporte Pharex',
                permission: 'Reporte Pharex',
                breadcrumb: [{
                    text: ' Dashboard',
                    href: '#/'
                },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Reporte Pharex',
                        href: '#/reporte-pharex'
                    }
                ]
            }
        },
        {
            path: "/gestion-cotizaciones",
            component: resolve => require(["../views/quotations/index"], resolve),
            meta: {
                title: "Gestión de cotizaciones",
                permission: "Gestión de cotizaciones",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                         text: "Gestión de cotizaciones",
                         href: "#/gestion-cotizaciones"
                     }
                ]
            },
        },
        {
            path: "/reporte-excel-inventario",
            component: resolve => require(["../views/excel-inventory/index.vue"], resolve),
            meta: {
                title: "Excel Contable Inventario",
                permission: "Excel Contable Inventario",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Excel Contable Inventario",
                        href: "#/reporte-saldos-por-tercero"

                    }
                ]
            }
        },

        {
            path: "/consignacion-cheques",
            component: resolve => require(["../views/check-consignment/index.vue"], resolve),
            meta: {
                title: "Consignación De Cheques",
                permission: "Consignacion De Cheques",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Consignación De Cheques",
                        href: "#/consignacion-cheques"
                    }
                ]
            }
        },
        {
          path: "/cancelacion-saldos-menores",
            component: resolve => require(["../views/balance_cancelation/index.vue"], resolve),
            meta: {
                title: "Cancelación de Saldos Menores",
                permission: "Cancelacion de Saldos Menores",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Cancelación de Saldos Menores",
                        href: "#/conicliacion-saldos-menores"
                    }
                ]
            }
        },
        {
          path: "/re-clasificacion-cartera-alkosto",
            component: resolve => require(["../views/portfolio_reclassification/index.vue"], resolve),
            meta: {
                title: "Reclasificación Cartera Alkostos",
                permission: "Reclasificacion Cartera Alkostos",

                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Reclasificación Cartera Alkostos",
                        href: "#/re-clasificacion-cartera-alkostos"
                    }
            ]
            }
        },
        {
            path: '/solicitud-garantias',
            component: resolve => require(['../views/guarantees_admin/index.vue'], resolve),
            meta: {
                title: 'Gestión Garantías y devoluciones',
                permission: 'Gestión Garantías y devoluciones',
                breadcrumb: [{
                    text: ' Dashboard',
                    href: '#/'
                },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Gestión Garantías y devoluciones',
                        href: '#/solicitud-garantias'
                    }
                ]
            }
        },
        {
          path: '/validacion-kardex',
          component: resolve => require(['../views/validate-kardex/index.vue'], resolve),
          meta: {
            title: 'Validacion kardex',
            permission: 'Validacion kardex',
            breadcrumb: [{
                text: ' Dashboard',
                href: '#/'
              },
            ]
          }
        },
        {
          path: "/tabla-parametros/:table_id",
          component: resolve =>
              require(["../views/table-parameters/index.vue"], resolve),
          props: true,
          meta: {
              title: "",
              permission: "",
              parameter: "table_id",
              function_execute: async table_id => {
                  let table = JSON.parse(localStorage.getItem("selectedTableParams"));

                    if (!table || +table.id !== +table_id) {
                        await $http.get("/api/tablas-parametros/" + table_id).then(response => {
                            table = response.data.data;
                            console.log(table, response.data)
                            localStorage.setItem("selectedTableParams", JSON.stringify(table));
                        });
                    }
                    return table.code_table + "-" + table.name_table;
                },
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Sistema de inventarios",
                        href: "#/tabla-parametros"
                    }
                ]
            }
        },
        {
            path: '/datafonos',
            component: resolve => require(['../views/dataphones/index'], resolve),
            meta: {
                title: 'Configuración Datafonos',
                permission: 'Configuración Datafonos',
                breadcrumb: [{
                    text: ' Dashboard',
                    href: '#/'
                },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Configuración Datafonos',
                        href: '#/solicitud-garantias'
                    }
                ]
            }
        },
        {
            path: "/datafonos/:idv/ver",
            component: resolve =>
                require(["../views/dataphones/form.vue"], resolve),
            meta: {
                title: "Configuración Datafonos",
                permission: 'Configuración Datafonos',
                breadcrumb: []
            }
        },
        {
            path: "/datafonos/:id/editar",
            component: resolve =>
                require(["../views/dataphones/form.vue"], resolve),
            meta: {
                title: "Configuración Datafonos",
                permission: 'Configuración Datafonos',
                breadcrumb: []
            }
        },
        {
            path: "/datafonos/crear",
            component: resolve =>
                require(["../views/dataphones/form.vue"], resolve),
            meta: {
                title: "Configuración Datafonos",
                permission: 'Configuración Datafonos',
                breadcrumb: []
            }
        },
        {
            path: "/reporte-maximos-minimos",
            component: resolve => require(["../views/report-max-min/index"], resolve),
            meta: {
                title: "Informe Máximos y Mínimos",
                permission: "Informe Máximos y Mínimos",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Informe Máximos y Mínimos",
                        href: "#/reporte-maximos-minimos"

                    },

                ]
            }
        },
        {
            path: "/informe-reposicion-v2",
            component: resolve =>
                require(["../views/report-inventory-replacement-v2/index"], resolve),
            meta: {
                title: "Informe de Reposición de Inventario V2",
                permission: 'Informe de Reposicion de Inventario V2',
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Informe de Reposición de Inventario V2",
                        href: "#/informe-reposicion-v2"
                    }
                ]
            }
        },
        {
          path: "/contact-balance",
          component: resolve =>
              require(["../views/contact-balance/index.vue"], resolve),
          meta: {
              title: "Balance por Tercero",
              permission: "Balance por Tercero",
              breadcrumb: [
                  {
                      text: " Dashboard",
                      href: "#/"
                  },
                  {
                      text: "Administración Starcommerce",
                      href: "#"
                  },
                  {
                      text: "Sistema de inventarios",
                      href: "#/traslado"
                  }
              ]
          }
        },
          {
            path: "/reporte-usuarios-documentos",
            component: resolve => require(["../views/report-user-documents/index"], resolve),
            meta: {
                title: "Movimientos de Usuarios / Documento",
                permission: "Movimientos de Usuarios",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Movimientos de Usuarios / Documento",
                        href: "#/reporte-usuarios-documentos"
                    },
                ]
            }
        },
        {
            path: "/reporte-traslados",
            component: resolve => require(["../views/report-transfers/index.vue"], resolve),
            meta: {
                title: "Informe de Traslados",
                permission: "Informe de Traslados",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Informe de Traslados",
                        href: "#/reporte-traslados"
                    }
                ]
            }
        },
        {
            path: '/conceptos-contables',
            component: resolve => require(['../views/accounting_concepts/index'], resolve),
            meta: {
                title: 'Conceptos Contables',
                permission: 'Conceptos Contables',
                breadcrumb: [{
                    text: ' Dashboard',
                    href: '#/'
                },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Conceptos Contables',
                        href: '#/conceptos-contables'
                    }
                ]
            }
        },
        {
            path: "/conceptos-contables/:idv/ver",
            component: resolve =>
                require(["../views/accounting_concepts/form"], resolve),
            meta: {
                title: "Conceptos Contables",
                permission: 'Conceptos Contables',
                breadcrumb: []
            }
        },
        {
            path: "/conceptos-contables/:id/editar",
            component: resolve =>
                require(["../views/accounting_concepts/form.vue"], resolve),
            meta: {
                title: "Conceptos Contables",
                permission: 'Conceptos Contables',
                breadcrumb: []
            }
        },
        {
            path: "/reposicion-puntos-de-venta",
            component: resolve =>
                require(["../views/replacement_points_of_sale/index.vue"], resolve),
            meta: {
                title: "Reposición por punto de venta",
                permission: 'REPOSICIÓN POR PUNTO DE VENTA',
                breadcrumb: []
            }
        },
        {
            path: "/conceptos-contables/crear",
            component: resolve =>
                require(["../views/accounting_concepts/form.vue"], resolve),
            meta: {
                title: "Conceptos Contables",
                permission: 'Conceptos Contables',
                breadcrumb: []
            }
        },
        {
          path: "/informe-documentos-pendientes-orden-despacho",
          component: resolve =>
              require(["../views/document-pending-dispatch-order/index.vue"], resolve),
          meta: {
            title: "Documentos Pendientes Orden Despacho",
            permission: "Documentos Pendientes Orden Despacho",
            breadcrumb: [
              {
                text: " Dashboard",
                href: "#/"
              },
              {
                text: "Administración Starcommerce",
                href: "#"
              },
              {
                text: "Documentos Pendientes Orden Despacho",
                href: "#/informe-documentos-pendientes-orden-despacho"
              }
            ]
          }
        },
        {
            path: "/novedades-caja",
            component: resolve => require(["../views/cash-registers-updates/index.vue"], resolve),
            meta: {
                title: "Caja y Novedades",
                permission: "Caja y Novedades",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Caja y Novedades",
                        href: "#/novedades-caja"
                    }
                ]
            }
        },
        {
            path: "/novedades-caja/crear",
            component: resolve => require(["../views/cash-registers-updates/cash-register-updates-form"], resolve),
            meta: {
                title: "Caja y Novedades",
                permission: "Caja y Novedades",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Caja y Novedades",
                        href: "#/novedades-caja"
                    }
                ]
            }
        },
        {
            path: "/novedades-caja/:id/editar",
            component: resolve => require(["../views/cash-registers-updates/cash-register-updates-form"], resolve),
            meta: {
                title: "Caja y Novedades",
                permission: "Caja y Novedades",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Caja y Novedades",
                        href: "#/novedades-caja"
                    }
                ]
            }
        },
        {
            path: "/novedades-caja/:idv/ver",
            component: resolve => require(["../views/cash-registers-updates/cash-register-updates-form"], resolve),
            meta: {
                title: "Caja y Novedades",
                permission: "Caja y Novedades",
                breadcrumb: [
                    {
                        text: " Dashboard",
                        href: "#/"
                    },
                    {
                        text: "Administración Starcommerce",
                        href: "#"
                    },
                    {
                        text: "Caja y Novedades",
                        href: "#/novedades-caja"
                    }
                ]
            }
        },
        {
          path: "/reportes/conciliacion-bancaria",
          component: resolve =>
              require(["../reports-aggrid/views/BankConciliation/redirect"], resolve),
          meta: {
            title: "Conciliacion Bancaria",
            permission: "Conciliacion Bancaria",
            breadcrumb: [
              {
                text: " Dashboard",
                href: "#/"
              },
              {
                text: "Administración Starcommerce",
                href: "#"
              },
              {
                text: "Conciliacion Bancaria",
                href: "#/reportes/conciliacion-bancaria"
              }
            ]
          }
        },
        {
          path: "/inventarios-ideales/importar",
          component: resolve =>
              require(["../views/import-ideal-balances/index.vue"], resolve),
          meta: {
            title: "Importar Inventarios Ideales",
            permission: "Importar Inventarios Ideales",
            breadcrumb: [
              {
                text: " Dashboard",
                href: "#/"
              },
              {
                text: "Administración Starcommerce",
                href: "#"
              },
              {
                text: "Importar Inventarios Idealess",
                href: "#/inventarios-ideales/importar"
              }
            ]
          }
        },

      //   envio automatico de la cartera
      {
        path: "/reporte-relacion-documentos",
        component: resolve =>
            require(["../views/report-sales-referrals/index.vue"], resolve),
        meta: {
          title: "Informe de Relación de Documentos",
          permission: "Informe de Relación de Documentos",
          breadcrumb: [
            {
              text: " Dashboard",
              href: "#/"
            },
            {
              text: "Administración Starcommerce",
              href: "#"
            },
            {
              text: "Informe de Relación de Documentos",
              href: "#/informe-relacion-documentos"
            }
          ]
        }
      },
      {
            path: '/inventario-fisico',
            component: resolve => require(['../views/physical-inventory/index'], resolve),
            meta: {
                title: 'Inventario Fisico',
                permission: 'Inventario Fisico',
                breadcrumb: [{
                    text: ' Dashboard',
                    href: '#/'
                },
                    {
                        text: 'Administración Starcommerce',
                        href: '#'
                    },
                    {
                        text: 'Inventario Fisico',
                        href: '#/inventario-fisico'
                    }
                ]
            }
      }
    ]
  },
  {
    path: "/500",
    component: resolve => require(["../components/pages/500.vue"], resolve),
    meta: {
      title: "500",
      breadcrumb: ``
    }
  },
  {
    path: "/login",
    component: resolve => require(["../components/pages/login.vue"], resolve),
    meta: {
      title: "Login",
      breadcrumb: ``
    }
  },
  {
    path: "/register",
    component: resolve =>
      require(["../components/pages/register.vue"], resolve),
    meta: {
      title: "Register",
      breadcrumb: ``
    }
  },
  {
    path: "/salvapantallas",
    component: resolve =>
      require(["../components/pages/lockscreen.vue"], resolve),
    meta: {
      title: "Lockscreen",
      breadcrumb: ``
    }
  },
  {
    path: "/olvide/contrasena",
    component: resolve =>
      require(["../components/pages/forgot_password.vue"], resolve),
    meta: {
      title: "Olvide mi contraseña",
      breadcrumb: ``
    }
  },
  {
    path: "/restablecer/contrasena/:token",
    component: resolve =>
      require(["../components/pages/reset_password.vue"], resolve),
    meta: {
      title: "Restablecer contraseña",
      breadcrumb: ``
    }
  },
  {
    path: "/cambiar/contrasena",
    component: resolve =>
      require(["../components/pages/change_password.vue"], resolve),
    meta: {
      title: "Cambiar contraseña",
      breadcrumb: []
    }
  },
  {
    path: "*",
    component: resolve => require(["../components/pages/404.vue"], resolve),
    meta: {
      title: "404",
      breadcrumb: ``
    }
  }
];

let routes = baseRoutes.concat(b2bRoutes);

routes = routes.concat(reports_routes);
routes = routes.concat(reports_point_of_sale);

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js